import React from 'react';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import { COLOR_PRIMARY_1 } from 'src/utils/colors';

const UnlistedChip = ({ noShadow }: { noShadow?: boolean }) => {
  return (
    <Tooltip title="This listing was last active on Airbnb 3 months ago.">
      <Chip
        label="Unlisted"
        sx={{
          backgroundColor: '#ffff',
          color: COLOR_PRIMARY_1,
          '&:hover': { cursor: 'pointer' },
          boxShadow: noShadow
            ? 'none'
            : '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)',
          border: noShadow ? `1px solid ${COLOR_PRIMARY_1}` : 'none',
        }}
      />
    </Tooltip>
  );
};

export default UnlistedChip;
